import React, { Component, useState } from 'react'
import { getYear, getMonth, setYear, setMonth } from 'date-fns'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import _ from 'lodash';
import Select from 'react-select'

export default function BirthdatePicker(props) {
    const [isDatepickerOpen, setIsDatepickerOpen] = useState(false)
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedMonth, setSelectedMonth] = React.useState(null);
    const [selectedYear, setSelectedYear] = React.useState(null);
    const yearsList = _.range(getYear(new Date()),1899, -1);

    const years = yearsList.map((year) => { let y = {value: year, label: year}; return y; });
    const months = props.lang === 'en' ? [
        { value: 0, label: 'January' }, { value: 1, label: 'February' },
        { value: 2, label: 'March' }, { value: 3, label: 'April' },
        { value: 4, label: 'May' }, { value: 5, label: 'June' },
        { value: 6, label: 'July' }, { value: 7, label: 'August' },
        { value: 8, label: 'September' }, { value: 9, label: 'October' },
        { value: 10, label: 'November' }, { value: 11, label: 'December' }
    ] : [
        { value: 0, label: 'Janvier' }, { value: 1, label: 'Février' },
        { value: 2, label: 'Mars' }, { value: 3, label: 'Avril' },
        { value: 4, label: 'Mai' }, { value: 5, label: 'Juin' },
        { value: 6, label: 'Juillet' }, { value: 7, label: 'Août' },
        { value: 8, label: 'Septembre' }, { value: 9, label: 'Octobre' },
        { value: 10, label: 'Novembre' }, { value: 11, label: 'Décembre' }
    ]

    const getMonths = (date) => {
        return getMonth(date);
    }

    const changeDate = (date) => {
        console.log(date);
        setSelectedDate(date);

        let dob = date;
        props.changeDate(dob);
    }

    const monthChange = (date, month) => {
        setSelectedMonth(month);
        console.log("MONTH",month);
        let d = new Date();
        if(date === null || date === undefined){
            d = setMonth(d, month.value);
        } else {
            d = setMonth(date, month.value);
        }

        if(selectedYear === null){
            setSelectedDate(d);
        } else {
            d = setYear(d, selectedYear);
            setSelectedDate(d);
        }
        console.log("Date",d);
        props.changeDate(d);
    }


    const yearChange = (date, year) => {
        setSelectedYear(year);
        console.log("YEAR",year);
        let d = new Date();
        if(date === null || date === undefined){
            d = setYear(d, year);
        } else {
            d = setYear(date, year);
        }

        if(selectedMonth === null){
            setSelectedDate(d);
        } else {
            console.log("selectedMonth",selectedMonth)
            d = setMonth(d, selectedMonth.value);
            setSelectedDate(d);
        }
        console.log("Date",d);
        props.changeDate(d);
    }


    const yearStyles = {
        menu: (provided, state) => ({
            ...provided,
            width: 85,
        }),
        control: (base) => ({
            ...base,
            width: 85,
            flexDirection: "row",
        }),
        input: (defaultStyles) => ({
            ...defaultStyles,
            color: '#495057',
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            color: '#495057',
        }),
        singleValue: (defaultStyles) => ({
            ...defaultStyles,
            color: '#495057',
        }),
    }

    const monthStyles = {
        menuList: (provided, state) => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        menu: (provided, state) => ({
            ...provided,
            width: 125,
        }),
        control: (base) => ({
            ...base,
            width: 125,
            flexDirection: "row",
        }),
        input: (defaultStyles) => ({
            ...defaultStyles,
            color: '#495057',
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            color: '#495057',
        }),
        singleValue: (defaultStyles) => ({
            ...defaultStyles,
            color: '#495057',
        }),
    }

    return (
        <DatePicker
            className={isDatepickerOpen ? 'form-control datepicker-hoverhack' : 'form-control'}
            strictParsing
            disabledKeyboardNavigation
            renderCustomHeader={({
                date, changeYear, changeMonth,
                decreaseMonth, increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled
            }) => (
                <div
                    style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center"
                    }}
                >

                <Select
                    placeholder={selectedDate === null ? years[0].label : selectedDate.getFullYear()}
                    styles={yearStyles}
                    isSearchable={false}
                    value={years.value}
                    onChange={ (year) => {yearChange(date, year.value); changeYear(year.value)}}
                    options={years}
                />

                <Select
                    styles={monthStyles}
                    isSearchable={false}
                    value={months[getMonths(date)]}
                    onChange={ (month) => {monthChange(date, month); changeMonth(months.indexOf(month))}}
                    options={months}
                />

                </div>
            )}
            selected={selectedDate}
            onChange={date => changeDate(date)}
            onChangeRaw={e => e.preventDefault()}
            onFocus={e => e.target.blur()}
            onCalendarOpen={_ => setIsDatepickerOpen(true)}
            onCalendarClose={_ => setIsDatepickerOpen(false)}
            dateFormat="dd/MM/yyyy"
            popperPlacement="top"
            placeholderText="DD/MM/YYYY"
        />
    );
}
